
//= include game-pixel-peak/game-screens/boot.js
//= include game-pixel-peak/game-screens/load.js
//= include game-pixel-peak/game-screens/menu.js
//= include game-pixel-peak/game-screens/play.js
//= include game-pixel-peak/game-screens/game.js
